import { endOfDay, startOfDay } from 'date-fns';
import { urls } from '@/config/urls';
import { instance } from '@/config/axios';

const { server } = urls;


export default {

  abortFetch () {
    return new Promise((resolve) => {
      resolve(false);
    });
  },
  getRoutesByProcess ({ optimization_id }) {
    return instance.get(`${server.process.processes}${optimization_id}`);
  },

  getRouteStringByProcessId (optimization_id) {
    return instance.get(`${server.process.processes}${optimization_id}/polylines`);
  },

  getRoutesByRange ({ startDate, endDate }, { page, max = 20, optimization_id, multi = false }) {
    const start = startOfDay(new Date(startDate)).toISOString();
    const end = endOfDay(new Date(endDate)).toISOString();
    const byProcessId = optimization_id ? `&optimization_id=${optimization_id}` : '';
    return instance.get(`${server.route.routes}bydate?from=${start}&to=${end}&page=${page}&max=${max}${byProcessId}&multi=${multi}`, {
    });
  },

  getRoutes (filter) {
    if(filter) {
      return instance.get(`${server.route.routes}q=${encodeURIComponent(filter)}`);
    }
    return instance.get(`${server.route.routes}`);
  },

  getRoutesInMonth (month) {
    return instance.get(server.route.monthly + month, {});
  },

  getMultiDeliveryAsync (id) {
    return instance.get(server.delivery.multidelivery + id)
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  getDeliveryByIDAsync (ID) {
    return instance.get(`${server.delivery.details + ID}?driver=true`, ({}))
      .catch((error) => {
        return Promise.reject(error);
      });
  },

  getRouteStringByRange ({ startDate, endDate }) {
    const start = startOfDay(new Date(startDate)).toISOString();
    const end = endOfDay(new Date(endDate)).toISOString();
    const url = `${server.route.routestring}?from=${start}&to=${end}`;
    return instance.get(url);
  },

  cancelRoutesByDate ({ startDate, endDate }) {
    const start = startOfDay(new Date(startDate)).toISOString();
    const end = endOfDay(new Date(endDate)).toISOString();
    return instance.post(`${server.route.cancelroute}bydate?from=${start}&to=${end}`, +'&force=true');
  },

  asyncGETRouteByID (ID, multi = true) {
    return instance.get(`${server.route.routes + ID}?multi=${multi}`, ({}))
      .catch((error) => {
        throw error;
      });
  },

  patchRoute (id, data) {
    return instance.patch(server.route.routes + id, data)
      .catch((error) => {
        throw error;
      });
  },

  archiveRoute (routeId) {
    return instance.post(server.route.cancel + routeId)
      .catch((error) => {
        toastr.error('Tour ' + this.route.id + i18next.t('common:routes.group.deleteTourErr'), errorConfig);
        throw error;
      });
  },

};
